module.exports = __webpack_public_path__ + "img/20190706155629YY截图20190704013447.4c84bd8a.png";